module.exports = __webpack_public_path__ + "img/N774-1-EN.2445cf98.png";